module.exports = __webpack_public_path__ + "static/media/crockpot_logo.239d8f52.png";